import * as React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Actions } from '../constants/components/AcceptDialog'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

interface AcceptDialogProps {
  action?: string
  isAcceptDialogOpen: boolean
  handleDialogClose: () => void
  acceptBid?: () => void
  acceptAdditionalItem?: () => void
  declineAdditionalItem?: () => void
  deleteImage?: () => void
  acceptSmsNotifications?: (event: any) => void
  declineSmsNotifications?: (event: any) => void
}

interface AcceptDialogState {
  isAcceptDialogOpen: boolean
}

export class AcceptDialog extends React.Component<AcceptDialogProps, AcceptDialogState> {
  constructor(props: any) {
    super(props)
    this.state = {
      isAcceptDialogOpen: this.props.isAcceptDialogOpen
    }
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props !== nextProps) {
      this.setState({
        isAcceptDialogOpen: nextProps.isAcceptDialogOpen
      })
    }
  }

  onKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.props.action === Actions.ACCEPT ? this.props.acceptAdditionalItem && this.props.acceptAdditionalItem() :
        this.props.action === Actions.DECLINE ? this.props.declineAdditionalItem && this.props.declineAdditionalItem() :
          this.props.action === Actions.DELETE ? this.props.deleteImage && this.props.deleteImage() :
            this.props.action === Actions.ACCEPT_SMS ? this.props.acceptSmsNotifications && this.props.acceptSmsNotifications(e) :
              this.props.acceptBid && this.props.acceptBid()
    }
  }

  getTitle() {
    let action = this.props.action
    switch (action) {
      case Actions.ACCEPT:
        return StringResources.getString(Strings.Components.AcceptDialog.Titles.Accept)
      case Actions.DECLINE:
        return StringResources.getString(Strings.Components.AcceptDialog.Titles.Decline)
      case Actions.DELETE:
        return StringResources.getString(Strings.Components.AcceptDialog.Titles.Confirm)
      case Actions.ACCEPT_SMS:
        return StringResources.getString(Strings.Components.AcceptDialog.Titles.SmsTitle)
      default:
        return StringResources.getString(Strings.Components.AcceptDialog.Titles.BidAccept)
    }
  }

  getContent() {
    let action = this.props.action
    switch (action) {
      case Actions.ACCEPT:
        return StringResources.getString(Strings.Components.AcceptDialog.Content.Accept)
      case Actions.DECLINE:
        return StringResources.getString(Strings.Components.AcceptDialog.Content.Decline)
      case Actions.DELETE:
        return StringResources.getString(Strings.Components.AcceptDialog.Content.Delete)
      case Actions.ACCEPT_SMS:
        return StringResources.getString(Strings.Components.AcceptDialog.Content.SmsContent)
      default:
        return StringResources.getString(Strings.Components.AcceptDialog.Content.BidAccept)
    }
  }

  getOnClick() {
    let action = this.props.action
    switch (action) {
      case Actions.ACCEPT:
        return this.props.acceptAdditionalItem
      case Actions.DECLINE:
        return this.props.declineAdditionalItem
      case Actions.DELETE:
        return this.props.deleteImage
      case Actions.ACCEPT_SMS:
        return this.props.acceptSmsNotifications
      default:
        return this.props.acceptBid
    }
  }

  render() {
    return (
      <Dialog
        open={this.state.isAcceptDialogOpen}
        onClose={this.props.handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="job-cancel-dialog"
        classes={{ paper: 'job-cancel-dialog-paper' }}
      >
        <DialogTitle id="alert-dialog-title">
          {
            this.getTitle()
          }
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
              this.getContent()
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={
              this.props.action !== Actions.ACCEPT_SMS ?
                this.props.handleDialogClose :
                this.props.declineSmsNotifications
            }
            color="primary"
            tabIndex={0}
            autoFocus={true}
          >
            {
              this.props.action !== Actions.ACCEPT_SMS ?
                StringResources.getString(Strings.Components.AcceptDialog.Buttons.NO) :
                StringResources.getString(Strings.Components.AcceptDialog.Buttons.DONT_ALLOW)
            }
          </Button>
          <Button
            onClick={this.getOnClick()}
            color="primary"
            tabIndex={0}
            onKeyDown={this.onKeyDown}
            autoFocus={true}
          >
            {
              this.props.action !== Actions.ACCEPT_SMS ?
                StringResources.getString(Strings.Components.AcceptDialog.Buttons.YES) :
                StringResources.getString(Strings.Components.AcceptDialog.Buttons.OK)
            }
          </Button>
        </DialogActions>
      </Dialog >
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AcceptDialog.tsx